import React from "react";
import { Tooltip } from "@material-ui/core";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import UnfoldMoreIcon from "@material-ui/icons/UnfoldMore";

// Three-level date sort used by every server-paged list: "default" (the
// endpoint's own order) -> "newest" -> "oldest" -> back to "default". The value
// is sent to the server as ?dateSort= so it sorts the whole result set, and the
// PDF / Excel exports reuse the same params so they come out in the same order.
export const nextDateSort = (current) =>
  current === "default" || !current ? "newest" : current === "newest" ? "oldest" : "default";

const LABEL = { default: "Default order", newest: "Newest first", oldest: "Oldest first" };

const DateSortHeader = ({ value = "default", onChange, children = "Date" }) => {
  const Icon = value === "newest" ? ArrowDownwardIcon : value === "oldest" ? ArrowUpwardIcon : UnfoldMoreIcon;
  const active = value !== "default";
  return (
    <Tooltip title={`${LABEL[value]} - click for ${LABEL[nextDateSort(value)].toLowerCase()}`} arrow>
      <span
        role="button"
        tabIndex={0}
        aria-label={`Sort by date: ${LABEL[value]}`}
        onClick={() => onChange(nextDateSort(value))}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onChange(nextDateSort(value));
          }
        }}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 4,
          cursor: "pointer",
          userSelect: "none",
          color: active ? "#ea580c" : "inherit",
        }}
      >
        {children}
        <Icon style={{ fontSize: 16, opacity: active ? 1 : 0.45 }} />
        {active && (
          <span style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>
            {value === "newest" ? "New" : "Old"}
          </span>
        )}
      </span>
    </Tooltip>
  );
};

export default DateSortHeader;
